import { Icon, Tag, Text } from 'ui';

const CommunityJoinedStatusBadge = () => (
  <Tag color="success" icon={<Icon icon="check-circle-fill" />} noBackground size="medium">
    <Text>Joined</Text>
  </Tag>
);

export default CommunityJoinedStatusBadge;
